import React from 'react';
import PropTypes from 'prop-types';
import SimilarItem from './SimilarItem';

function SimilarItems({ items, onClick, itemIsUnavailable, currency }) {
    if (!items.length) {
        return null;
    }

    return (
        <div>
            {items.map((recommendations, recIndex) => {
                return (
                    <div className="rowFlex pdp-similar-items" key={`similar-${recIndex}`}>
                        {recommendations.map((item, index) => {
                            const position =
                                (recIndex === 0 ? index : recommendations.length + index) + 1;

                            return (
                                <SimilarItem
                                    item={item}
                                    onClick={() => onClick(item)}
                                    key={item.id}
                                    position={position}
                                    itemIsUnavailable={itemIsUnavailable}
                                    currency={currency}
                                />
                            );
                        })}
                    </div>
                );
            })}
        </div>
    );
}

SimilarItems.propTypes = {
    items: PropTypes.array.isRequired,
    onClick: PropTypes.func,
    itemIsUnavailable: PropTypes.bool,
    currency: PropTypes.string,
};

module.exports = SimilarItems;



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/Similar/SimilarItems.jsx